import doRequest, { addLog } from '@/api/dssRequest';
import uiHelpers from '@/shared/ui_helpers';

export default {
  mixins: [uiHelpers],
  data() {
    return {
      events: [],
    };
  },
  computed: {
    title() {
      const pgInfo = this.$store.getters['Account/partnerGroupDetails'];

      if (
        pgInfo != null &&
        pgInfo.TrendingTitle != null &&
        pgInfo.TrendingTitle.trim() !== ''
      ) {
        return pgInfo.TrendingTitle.trim();
      }
      return this.$translate('TRENDING');
    },
  },
  mounted() {
    this.getTrendingEvents();
  },
  methods: {
    getTrendingEvents() {
      const payload = {};

      doRequest(
        (response) => {
          this.events = response.data.TrendingEvents;
          if (this.events.length > 5) {
            this.events = this.events.slice(0, 5);
          }
        },
        () => {},
        'getTrendingEvents',
        'LocationsNode_ESE',
        payload,
        'GET'
      );
    },
    onEventClick(event) {
      // Add user interaction to log
      addLog(
        this.$store.getters['auth/userName'],
        event.EventId,
        'Event',
        'Home',
        -1
      );
      // route to event page
      this.goToPage('EventDetails', {
        event_id: event.EventId,
      });
    },
  },
};
